"use strict";
exports.__esModule = true;
var cart_1 = require("./cart/cart");
var App = /** @class */ (function () {
    function App() {
        new cart_1["default"]();
    }
    return App;
}());
$(document).ready(function () {
    new App();
});
